class HeaderHandler {
	constructor() {
		this.header = document.querySelector("#navbar");
		this.navigation = document.querySelector("#wpfront-notification-bar");
		this.fancyAnimator = document.querySelector("fancy-home-animator");
		this.heroBlock = document.querySelector(".show-menu-after");
		this.seenCookie = document.cookie.includes("seenLandingPage=true");

		this.run();
		if(this.seenCookie) {
			this.showMenu();
		} else {
			if (this.fancyAnimator) {
				this.hideMenu();

				this.fancyAnimator.addEventListener("animationend", (event) => {
					if (event.animationName === "removeOverlay") {
						this.showMenu();
					}
				});
			} else {
				this.showMenu();
			}
		}
	}

	run() {
		/*if (this.heroBlock) {
			// when scroll is past the hero block show the menu use the intersection observer
			const heroObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.hideMenu();
					} else {
						this.showMenu();
					}
				});
			});
			heroObserver.observe(this.heroBlock);
		}*/
	}

	showMenu() {
		this.header.style.overflow = "visible";
		this.header.style.height = "auto";
		this.header.style.opacity = "1";
		this.navigation.style.overflow = "visible";
		this.navigation.style.height = "auto";
		this.navigation.style.opacity = "1";
	}

	hideMenu() {
		this.header.style.opacity = "0";
		this.header.style.height = "0";
		this.navigation.style.opacity = "0";
		this.navigation.style.height = "0";
	}
}

new HeaderHandler();
